import {
  formatLength as formatLengthBase,
  getScalingFactor,
  LENGTH_INPUT_REGEX,
  lengthUnitLabel,
  parseLength as parseLengthBase,
  resolveLengthFormat,
  Scale,
} from '@ritabygglov/core';
import { useUser } from '../context/User/useUser';
import { useRoomId } from './useRoomId';

export const useMeasurement = () => {
  const user = useUser();
  const canvasId = useRoomId();
  const canvas = user.canvases.find((c) => c.canvasId === canvasId);
  const unitSystem = canvas?.unitSystem || 'metric';
  const lengthFormat = resolveLengthFormat(
    unitSystem,
    canvas?.lengthFormat || 'meters'
  );
  const scalingFactor = getScalingFactor(
    canvas?.drawingHeadScale as Scale,
    canvas?.pageFormat
  );

  return {
    unitSystem,
    lengthFormat,
    scalingFactor,
    // The unit to show next to an input, or null for imperial, whose
    // notation already carries its own unit.
    unitLabel: lengthUnitLabel(unitSystem, lengthFormat),
    formatLength: (metres: number) =>
      formatLengthBase(metres, unitSystem, lengthFormat),
    parseLength: (value: string) =>
      parseLengthBase(value, unitSystem, lengthFormat),
    unitInputRegex: LENGTH_INPUT_REGEX[unitSystem],
  };
};
